import React, { memo } from "react";
import PropTypes from "prop-types";

const Footer = ({ blurred, extraSpace, linksData }) => (
  <footer
    className={`main-f${blurred ? " blur-overlay" : ""}${
      extraSpace ? " main-f--extraspace" : ""
    }`}
  >
    <div className="main-f__mid">
      <div className="container">
        {linksData !== null &&
          linksData.map((section) => {
            let name = section.name;

            if (name === "EN TU MÓVIL") return null;

            return (
              <ul className="nostyle main-f__col" key={name}>
                <li className="main-f__col-title">{name.toUpperCase()}</li>
                {section.section.map((link) => {
                  const external = link.isExternal
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : "";
                  return (
                    <li key={link.title}>
                      <a href={link.link} {...external}>
                        {link.title}
                      </a>
                    </li>
                  );
                })}
              </ul>
            );
          })}
      </div>
    </div>
    <div className="main-f__bottom">
      <div className="container">
        <p>Contenido del sitio 2021 Yelmo Cines® de España, S.A. de C.V.</p>
        <p>
          Desarrollado por{" "}
          <a
            href="https://www.ia.com.mx/"
            target="_blank"
            rel="noopener noreferrer"
          >
            IA Interactive
          </a>
        </p>
      </div>
    </div>
  </footer>
);

Footer.propTypes = {
  blurred: PropTypes.bool,
  extraSpace: PropTypes.bool,
  linksData: PropTypes.array,
};

export default memo(Footer);
